export const classes = (...args) => [...args].filter(Boolean).join(' ')
